<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Settings</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Settings
        <button mat-raised-button style="background: green;color: white;margin-right: 10px;"
            (click)="Update_setting()"><mat-icon>save</mat-icon>Save</button>
    </div>
</div>
<div class="d-flex justify-content-center mb-2">
    <mat-card class="col-lg-9 col-sm-12">
        <mat-card-content>
            <div class="row ">
                <div class="row align-items-center mb-2">
                    <div class="col-lg-2 col-5">
                        <mat-label>Registration :</mat-label>
                    </div>
                    <div class="col-lg-10 col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="registration">
                            <mat-radio-button value="on">On</mat-radio-button>
                            <mat-radio-button value="off">Off</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row align-items-center mb-2">
                    <div class="col-lg-2 col-5">
                        <mat-label>Mobile Number Unique? :</mat-label>
                    </div>
                    <div class="col-lg-10 col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="unique_mobile">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row align-items-center mb-2">
                    <div class="col-lg-2 col-5">
                        <mat-label>Contact Detail privacy :</mat-label>
                    </div>
                    <div class="col-lg-10 col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="contact_privacy"
                            [disabled]="!Enable_Whatsapp_Url">
                            <mat-radio-button value="public">Public</mat-radio-button>
                            <mat-radio-button value="private">Private</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Reg ID Start From</mat-label>
                    <input matInput placeholder="1 - 1001" [(ngModel)]="start_reg_from">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Registration Success Message</mat-label>
                    <textarea matInput [(ngModel)]="success_msg"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Registration Close Message</mat-label>
                    <textarea matInput [(ngModel)]="close_msg"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Display Message
                        <svg matTooltip="This message will be displayed in the app on the event details page"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"
                            color="#000000" fill="none">
                            <path
                                d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                stroke="currentColor" stroke-width="1.5" />
                            <path
                                d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.992 8H12.001" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </mat-label>
                    <textarea matInput [(ngModel)]="display_msg"></textarea>
                </mat-form-field>

                <hr>

                <div class="row align-items-center mb-2">
                    <div class="col-5">
                        <mat-label>Send Email On Registration :</mat-label>
                    </div>
                    <div class="col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="send_email">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row align-items-center mb-2">
                    <div class="col-5">
                        <mat-label>Send Whatsapp On Registration :</mat-label>
                    </div>
                    <div class="col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="send_whatsapp_reg">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <mat-form-field *ngIf="send_email =='yes' || send_whatsapp_reg =='yes'" appearance="outline">
                    <mat-label>Whatsapp/Email Message On Registration</mat-label>
                    <textarea matInput [(ngModel)]="reg_whatsapp_msg"></textarea>
                </mat-form-field>

                <hr>
                <div class="row align-items-center mb-2">
                    <div class="col-5">
                        <mat-label>Print Preferance for ID-Card & Ticket :</mat-label>
                    </div>
                    <div class="col-7">
                        <mat-radio-group aria-label="Select an option" [(ngModel)]="ticket_print">
                            <mat-radio-button value="single">Single</mat-radio-button>
                            <mat-radio-button value="multiple">Multiple</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <hr>

                <mat-form-field class="d-flex form-container" appearance="outline">
                    <mat-label>Registration Link</mat-label>
                    <div class="input-button-container">
                        <input matInput placeholder="1 - 1001" [(ngModel)]="reg_url" [readonly]="!Enable_Whatsapp_Url">
                        <button mat-raised-button color="primary" (click)="copyLink()"><mat-icon
                                class="m-0">file_copy</mat-icon></button>
                        <button mat-raised-button color="accent" (click)="goToLink()"><mat-icon
                                class="m-0">link</mat-icon></button>
                    </div>
                </mat-form-field>

            </div>
        </mat-card-content>
        <!-- <mat-card-actions align="end">
            <button mat-raised-button color="primary" (click)="Update_setting()">Save</button>
        </mat-card-actions> -->
    </mat-card>
</div>
<div class="d-flex justify-content-center">
    <mat-card class="col-lg-9 col-sm-12">
        <mat-card-content>
            <div class="col-12 mb-3">
                <mat-label>WhatsApp API Settings</mat-label>
            </div>
            <!-- <mat-form-field appearance="outline" class="col-6 mb-3">
                <mat-label>Whatsapp Url</mat-label>
                <textarea matInput placeholder="Enter Whatsapp Api" [(ngModel)]="whatsapp_url"
                    [readonly]="!Enable_Whatsapp_Url"></textarea>
            </mat-form-field> -->

            <!-- API URL -->
            <mat-form-field appearance="outline" class="col-12 mb-3">
                <mat-label>API URL</mat-label>
                <input matInput placeholder="Enter API URL" [(ngModel)]="url" (ngModelChange)="onUrlChange($event)"
                    [readonly]="!Enable_Whatsapp_Url">
            </mat-form-field>

            <!-- Vendor ID -->
            <mat-form-field appearance="outline" class="col-12 mb-3">
                <mat-label>Vendor ID</mat-label>
                <input matInput placeholder="Enter Vendor ID" [(ngModel)]="vendor_id"
                    (ngModelChange)="onVendorChange($event)" [readonly]="!Enable_Whatsapp_Url">
            </mat-form-field>

            <!-- HTTP Method -->
            <mat-form-field appearance="outline" class="col-12 mb-3">
                <mat-label>HTTP Method</mat-label>
                <mat-select [(ngModel)]="method" [disabled]="!Enable_Whatsapp_Url">
                    <mat-option value="POST">POST</mat-option>
                    <mat-option value="GET">GET</mat-option>
                    <mat-option value="PUT">PUT</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Headers -->
            <mat-form-field appearance="outline" class="col-12 mb-3">
                <mat-label>Request Headers (JSON)</mat-label>
                <textarea matInput rows="4" placeholder='{"Content-Type":"application/json"}' [(ngModel)]="headers"
                    [readonly]="!Enable_Whatsapp_Url">
    </textarea>
            </mat-form-field>

            <!-- Body Template -->
            <mat-form-field appearance="outline" class="col-12 mb-3">
                <mat-label>Body Template (JSON)</mat-label>
                <textarea matInput rows="6" placeholder='{"phone":"[mobile]","message":"[message]"}'
                    [(ngModel)]="body_template" [readonly]="!Enable_Whatsapp_Url">
    </textarea>
            </mat-form-field>


            <div *ngIf="send_email =='yes'">
                <div class="col-12 mb-3">
                    <mat-label>Email Configuration</mat-label>
                </div>

                <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="col-12 mb-3">
                        <mat-label>SMTP Server (Hostname)</mat-label>
                        <input matInput placeholder="Hostname" [(ngModel)]="hostname" [readonly]="!Enable_Whatsapp_Url">
                    </mat-form-field>
                </div>


                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Port</mat-label>
                            <input matInput placeholder="Port Number" [(ngModel)]="port"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Security</mat-label>
                            <input matInput placeholder="tls/ssl" [(ngModel)]="security"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Username</mat-label>
                            <input matInput placeholder="Username" [(ngModel)]="username"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Password</mat-label>
                            <input matInput placeholder="Password" [(ngModel)]="password"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>From Email Address</mat-label>
                            <input matInput placeholder="From Email" [(ngModel)]="from_email"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>From name / Website Title</mat-label>
                            <input matInput placeholder="From name / Website Title" [(ngModel)]="title"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Subject</mat-label>
                            <input matInput placeholder="Subject" [(ngModel)]="email_subject"
                                [readonly]="!Enable_Whatsapp_Url">
                        </mat-form-field>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-form-field appearance="outline" class="col-12 mb-3">
                            <mat-label>Message</mat-label>
                            <textarea rows="10" matInput placeholder="Message" [(ngModel)]="email_template"
                                [readonly]="!Enable_Whatsapp_Url">
                            </textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>